import React, { useEffect, useState } from 'react';

// A helper function to shuffle an array in place using the Fisher–Yates algorithm.
function shuffleArray(array) {
  const newArray = array.slice();
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}

const ReviewedCandidatesPage = () => {
  const [groupedCandidates, setGroupedCandidates] = useState({});

  useEffect(() => {
    fetch(process.env.REACT_APP_API_BASE + 'reviewedcandidates')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Group candidates by ballotName.
        const groups = data.reduce((acc, candidate) => {
          // If the group does not exist yet, create it.
          if (!acc[candidate.ballotName]) {
            acc[candidate.ballotName] = [];
          }
          acc[candidate.ballotName].push(candidate);
          return acc;
        }, {});

        // Shuffle the candidates within each group.
        for (const ballot in groups) {
          groups[ballot] = shuffleArray(groups[ballot]);
        }
        
        setGroupedCandidates(groups);
      })
      .catch(error => {
        console.error("Error fetching candidates:", error);
      });
  }, []);

  // Get the ballot names (group keys) and optionally shuffle their order as well.
  const ballotNames = Object.keys(groupedCandidates);
  const shuffledBallotNames = shuffleArray(ballotNames);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Candidates for Student Government Elections</h1>
      {shuffledBallotNames.map(ballotName => (
        <div key={ballotName} style={{ marginBottom: '40px' }}>
          <h2>{ballotName}</h2>
          {groupedCandidates[ballotName].map(candidate => (
            <div
              key={candidate.candidateId}
              style={{
                border: '1px solid var(--neutral-border)',
                borderRadius: '4px',
                padding: '10px',
                marginBottom: '10px'
              }}
            >
              <img
              className='center-preview'
              style={{
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '50%',
                paddingBottom: '50px',
              }}
              src={
                candidate.imageFileName !== ''
                  ? process.env.REACT_APP_API_BASE +
                    'imageview/' +
                    candidate.candidateId +
                    '_' +
                    candidate.imageFileName
                  : 'no-picture-available-icon.jpg'
              }
              alt={`Candidate portrait for ${candidate.ballotCandidateName}`}
            />
              <div style={{ textAlign: 'center' }}>
                 <h3>{candidate.ballotCandidateName}</h3>
              </div>
              <div style={{ textAlign: 'center' }}>
                 <h4 className='h5'>{candidate.ballotCandidatePartyName ? candidate.ballotCandidatePartyName : 'Independent'}</h4>
              </div>
              <p>{candidate.candidateStatement}</p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ReviewedCandidatesPage;
